import { useCallback, useMemo, useState } from 'react';
import { getCuratedStatus } from './usePolicy';
import { IssuedSearchPolicy } from './useSearchPolicies';

interface StatusFilterOption {
  label: string;
  value: ReturnType<typeof getCuratedStatus>;
}

const options: StatusFilterOption[] = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Canceled',
    value: 'cancelled',
  },
  {
    label: 'Expired',
    value: 'expired',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
];

export const usePolicyStatusFilter = () => {
  const [value, setValue] = useState<string[]>([]);

  const handleValueChange = useCallback(
    (next: string[]) => {
      // to guarantee the value order
      const nextValue = options
        .filter((option) => next.includes(option.value))
        .map((option) => option.value);

      setValue(nextValue);
    },
    [setValue]
  );

  const isMatch = useCallback(
    (policy: IssuedSearchPolicy) => {
      const curatedStatus = getCuratedStatus(policy);
      return value.includes(curatedStatus);
    },
    [value]
  );

  const key = useMemo(() => {
    return value.join(',');
  }, [value]);

  return {
    handleValueChange,
    isMatch,
    key,
    options,
    value,
  };
};
